import { CardContent, Grid, Container, Paper, Typography, ThemeProvider, createMuiTheme } from "@material-ui/core";
import React from "react";



function About(props) {

  const theme = createMuiTheme({
    typography:{
      fontFamily: 'Raleway, Arial',
      fontStyle: 'normal',
      fontWeight: 400
    }
  })

  const {about} = props
  return (
    <ThemeProvider theme={theme}>
    <Container
      container
      id = "about"
      style={{
        width:"100%",
        backgroundColor: "#181E2F",
        color: "white",
        maxWidth:"100%",

        
      }}
    >
      <Grid
        container
        justify="center"
        direction="row"
        spacing={6}
        style={{
          
          width:"100%",
          margin:"0 auto",
          padding: "60px 0 40px 0",
          maxWidth: "1400px"
        }}
      >
        
        {/* TODO rješiti responzivnost ako treba */}
        <Grid item xs={12} sm={12} md={6}>
          <Typography variant="h5"
              style={{
              color:"#1F94C2",
              marginBottom: "20px"
            }}
          >O Konferenciji</Typography>
          <Typography variant="body2" >
            {about[0].value}
          </Typography>
        </Grid>

        <Grid item xs={12} sm={12} md={3}>
          <Typography variant="h5"
            style={{
              color:"#1F94C2",
            marginBottom: "20px"
          }}
          >GDJE</Typography>
          <Typography variant="body2"> {about[1].value}</Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={3}>
          <Typography variant="h5"
            style={{
              color:"#1F94C2",
            marginBottom: "20px"
          }}
          >KADA</Typography>
          <Typography variant="body2">
          {about[2].value}
          </Typography>
        </Grid>
        </Grid>
      </Container>
      </ThemeProvider>
  );
}

export default About;
